import React, { useState } from 'react';

import { ContentContainer, RightContainer, LeftContainer, ListItem, ItemText, Card } from './styles';

export default function AnchorContent({ anchorPoints, hideOnSmallDevice }) {
  const [active, setActive] = useState(0);

  const executeScroll = (index) => {
    setActive(index);
    let element = document.getElementById(index);
    let headerOffset = 60;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };
  // run this function from an event handler or an effect to execute scroll

  return (
    <ContentContainer>
      <LeftContainer hideOnSmallDevice={hideOnSmallDevice}>
        {anchorPoints.map((item, index) => (
          <ListItem key={index} active={index === active} onClick={() => executeScroll(index)}>
            {item.icon && <i className={item.icon}></i>}
            <ItemText> {item.label}</ItemText>
          </ListItem>
        ))}
      </LeftContainer>
      <RightContainer>
        {anchorPoints.map((item, index) => (
          <Card key={index} id={index}>
            {item.component}
          </Card>
        ))}
      </RightContainer>
    </ContentContainer>
  );
}
